var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadmapIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_867_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1514 12.3552C44.094 11.0924 44.094 9.887 44.094 8.68161C44.094 7.70583 43.3478 6.95964 42.372 6.95964C35.1971 6.95964 29.7442 4.89327 25.2097 0.473543C24.5209 -0.157848 23.4877 -0.157848 22.7989 0.473543C18.2644 4.89327 12.8115 6.95964 5.63658 6.95964C4.66079 6.95964 3.9146 7.70583 3.9146 8.68161C3.9146 9.887 3.9146 11.0924 3.85721 12.3552C3.62761 24.409 3.28321 40.9399 23.4303 47.8852L24.0043 48L24.5783 47.8852C44.668 40.9399 44.381 24.4664 44.1514 12.3552ZM22.6267 29.0583C22.2823 29.3453 21.8805 29.5175 21.4213 29.5175H21.3639C20.9047 29.5175 20.4455 29.2879 20.1586 28.9435L14.8204 23.0314L17.4034 20.7354L21.5935 25.3848L30.8922 16.5453L33.2455 19.0709L22.6267 29.0583Z",
    fill: "url(#paint0_linear_867_382)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_867_382",
    x1: 44.202,
    y1: 24,
    x2: 3.80469,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37A058"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_867_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapIcon3);
export default __webpack_public_path__ + "static/media/roadmap-icon-3.65b57c746d720aecb9e089734f640030.svg";
export { ForwardRef as ReactComponent };